import React from 'react';
import { replace } from 'lodash';

function convertOptionToTag(option = '') {
  return replace(option.toLowerCase(), /\s/, '_');
}

export default function RadioGroup({ groupName, options = [], required }) {
  return (
    <fieldset id={groupName} style={{ display: 'flex', flexFlow: 'row wrap' }} >
      {
        options.map((option, index) => {
          const tag = convertOptionToTag(option);

          return <div key={`radio_group_option_label_${tag}_${index}`} style={{ marginRight: '10px' }} >
            <label htmlFor={tag} >{option}</label>
            <input name={groupName} id={tag} type="radio" value={option} required={required} />
          </div>;
        })
      }
    </fieldset>
  );
}